.w2d-live-wins-swiper-section {
  &__hidden-content {
    display: none;
  }

  &__swiper-wrapper {
    background-color: var(--ace-color-surface-solid--300);
    border-radius: var(--ace-primitive-radius-medium);
    padding: var(--ace-primitive-spacing-x-tight);
		overflow: hidden;

    @include mq($tablet) {
      padding: var(--ace-primitive-spacing-normal);
      border-radius: var(--ace-primitive-radius-large);
    }
  }

	&__swiper-el {
		width: 0;
		height: 0;
		opacity: 0;

		&--visible {
			width: 100%;
			height: 100%;
			opacity: 1;
			transition: 600ms ease-in-out;
		}
	}
}
